import { useEffect , useState } from 'react';
import { useHistory } from 'react-router-dom';
import { priceFormat } from 'util/prices'
import { repareImage } from 'newFunctions/repareDataService'
import ProductModal from 'newComponents/ProductsModal/ProductAddCart'
import { NO_IMAGE_DEFAULT } from 'constants/env'
import { decodeStorage } from 'functions/storageBase64';
import ProductsSuccessAdd from 'newComponents/ProductsModal/ProductSuccessAdd';
import styles from '../styles.module.sass'


const CardProduct = (props) => {

    const {
        eventId,
        eventoNo,
        item: producto,
        productsToCart,
        setAddProduct,
        responseTable
    } = props

    const isMobile = 'desktop'
    const userProfile = decodeStorage('profileData')
    const idSears = userProfile ? String(userProfile?.idClaro) : null
    const history = useHistory();

    const [ sendAddProduct, setSendAddProduct ] = useState(false)
    const [ productAdded, setProductAdded ] = useState(false)
    const [ clickAddProduct, setClickAddProduct ] = useState(false)
    const [ clickPaymentProduct, setClickPaymentProduct ] = useState(false)


    const image = producto?.pictures ? producto?.pictures[0]?.source.indexOf('?') === -1 ? `${producto?.pictures[0]?.source}?scale=250` :`${producto?.pictures[0]?.source}&scale=250` : NO_IMAGE_DEFAULT
    
    const categoryID = producto?.categories?.length === 1 
        ? producto?.categories[0]?.length >= 1
            ? producto?.categories[0]?.map(category => category?.id) 
            : Object.values(producto?.categories[0])?.map(category => category?.id)
        : []

    const [danger, setDatner] = useState()
    useEffect(()=>{
        if(categoryID?.length <=2 ){
            setDatner(true)
        }
    },[categoryID])
    
    const variantSelected =  typeof producto?.variantSelected === 'string' ? producto?.variantSelected : null

    const productToSend = {
        product_sears_id: producto?.id,
        variant_sears_id: producto?.variant_id,
        children_sku_sears: variantSelected,
        sku: producto?.sku,
        quantity: 1,
        category_sears_ids: categoryID,
        division_sears_id: producto?.division,
        ean: producto?.ean,
        is_market_place: false
    }

    const [ showModal, setShowModal ] = useState(false)
    
    const handleClose = () => {
        setShowModal(false)
    }
    
    const modalAddCart = () => {
        // const productID = event.currentTarget.getAttribute('data-productid')
        // const amount = event.currentTarget.getAttribute('data-amount')
        // const variation = event.currentTarget.getAttribute('data-variation')
        // console.log(productID,' ',amount,' ',variation)
        
        if(!productAdded){
            setShowModal(true)
        }
    }

    const [errorProduct, setErrorProduct] = useState(false)
    const resettUrl = () => {
        setErrorProduct(false)
    }

    useEffect(()=>{
        if(clickAddProduct){
            setSendAddProduct(clickAddProduct)
            setTimeout(()=>{
                setErrorProduct(true)
            },500)
            // console.log('clickAddProduct: ',clickAddProduct)
        }
        else if(clickPaymentProduct){
            setSendAddProduct(clickPaymentProduct)
            // console.log('clickPaymentProduct: ',clickPaymentProduct)
            setTimeout(()=>{
                if(idSears){
                    history.push(`/buy-gifts/${eventoNo}/buy`)
                }else{
                    history.push(`/pre-buy-gifts/${eventoNo}/buy`)
                }
            },500)
        }
    },[ clickAddProduct, clickPaymentProduct ])
    

    useEffect(()=>{
        if(productsToCart){
            setShowModal(false)
            if(productsToCart.filter(product => product.product_sears_id === producto?.id ||  product.children_sku_sears === producto?.variantSelected ).length >0 ){
                setProductAdded(true)
            }else{
                setProductAdded(false)
            }
        }else{
            setProductAdded(false)
        }
    },[ productsToCart ])


    useEffect(()=>{
        if(sendAddProduct){
            const newPayload = {
                ...productToSend,
                ...sendAddProduct
            }
            // console.log('sendAddProduct: ',sendAddProduct)
            // console.log('clickAddProduct: ',clickAddProduct)
            // console.log('payload: ',productToSend)
            // console.log('newPayload: ',newPayload)
            setAddProduct( { eventID: eventId, payload: newPayload } )
            setSendAddProduct(false)

        }
    },[ sendAddProduct ])

    return(
        producto?.stock >= 1 && producto?.is_active === true
            ? 
                <>
                    <article 
                        onClick={modalAddCart} 
                        className={danger ? `${styles?.cardProduct} ${styles?.cardGifts} ${styles?.disabled}` : `${styles?.cardProduct} ${styles?.cardGifts}`} 
                        data-productid={producto?.id} 
                        data-amount={producto?.amount} 
                        data-variation={producto?.variantSelected ? producto?.variantSelected : null} 
                        aria-hidden
                    >    
                        {productAdded
                            ?
                                <div className={styles?.agregado}>Producto agregado</div>
                            : null
                        }
                        {producto?.stock < 1
                            ?
                                <div className={styles?.soldOut}> Agotado</div>
                            : null
                        }
                        {danger
                            ?
                                <div className={styles?.soldOut}>Sin categoría</div>
                            : null
                        }
                        <img 
                            src={repareImage(image)} 
                            alt={producto?.title} 
                            className={producto?.stock >= 1 ? styles?.imageProduct : `${styles?.imageProduct} ${styles?.disabled}`} 
                        />
                        <div className={styles?.contProductInt}>
                            <p className={styles?.title}>{producto?.title}</p>
                            <div className={styles?.contPrices}>
                                <p className={styles?.salesPrice}>${priceFormat(producto?.pricing?.list_price)} MXN</p>
                            </div>
                            <p className={styles?.amount}>Cantidad: {producto?.amount}</p>
                        </div>
                    </article>

                    <ProductModal
                        showModal={showModal}
                        handleClose={handleClose}
                        isMobile={isMobile}
                        title={isMobile === 'desktop' ? 'Promociones' : 'Promociones Sanborns'} 
                        product={producto}
                        clickAddProduct={setClickAddProduct}
                        clickPaymentProduct={setClickPaymentProduct}
                        image={repareImage(image)}
                    />

                    {errorProduct
                        ?
                            <ProductsSuccessAdd
                                success={errorProduct}
                                setSuccess={setErrorProduct}
                                resettUrl={resettUrl}
                                responseTable={responseTable}
                                type={2}
                            />
                        : null
                    }

                </>
            : null
    )
}

export default CardProduct